export default "__VITE_ASSET__CtkBWQPM__"